import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlayerAuth } from '../contexts/PlayerAuthContext';
import { useTenant } from '../contexts/TenantContext';
import AppSplash from './AppSplash';

/**
 * Resolve the player-app entry route from tenant + auth state.
 *
 * | Context     | Logged in      | Logged out        |
 * |-------------|----------------|-------------------|
 * | Main site   | /player/home   | /public/open      |
 * | Tenant site | /player/home   | /public/tournaments |
 */
export function getPlayerAppEntryPath(
  isLoggedIn: boolean,
  hasTenant: boolean,
  tenantPath: (path: string) => string
): string {
  if (isLoggedIn) {
    return tenantPath('/player/home');
  }
  if (hasTenant) {
    return tenantPath('/public/tournaments');
  }
  return tenantPath('/public/open');
}

const AppOpenRedirect: React.FC = () => {
  const { isLoggedIn, isLoading } = usePlayerAuth();
  const { tenant, tenantPath } = useTenant();

  if (isLoading) {
    return <AppSplash />;
  }

  return (
    <Navigate
      to={getPlayerAppEntryPath(isLoggedIn, Boolean(tenant), tenantPath)}
      replace
    />
  );
};

export default AppOpenRedirect;
